<template>
    <div class="md:h-screen md:overflow-hidden">
        <div
            class="flex flex-col transition md:flex-row"
            :class="{ blurred: showForm }"
        >
            <div
                class="w-full overflow-y-auto md:w-2/5 lg:w-1/3 sm:max-h-screen"
            >
                <div
                    class="px-4 pt-4 bg-white border-r border-gray-200 lg:px-12 lg:pt-12"
                >
                    <div class="mb-8">
                        <a
                            target="_blank"
                            href="http://www.ocnioptikaolomouc.cz/"
                        >
                            <img
                                src="https://ocnioptikaolomouc.cz/images/logo.png"
                            />
                        </a>
                    </div>
                    <h1
                        class="mb-6 text-xl font-bold text-primary-200 lg:text-2xl"
                    >
                        Vyberte si termín návštěvy
                    </h1>
                    <p class="mb-8 text-sm text-gray-700">
                        Cílem naší práce je nabídnout Vám kompletní služby v
                        oblasti oční optiky, poradit Vám s problémy, které mohou
                        nastat při používání brýlí a aplikaci kontaktních čoček.
                    </p>
                    <div class="mb-8">
                        <datepicker
                            v-model="date"
                            :monday-first="true"
                            :full-month-name="true"
                            :disabled-dates="disabledDates"
                            :language="cs"
                            :inline="true"
                        ></datepicker>
                    </div>
                </div>
            </div>
            <div
                class="flex-1 h-screen px-4 py-4 overflow-y-auto bg-gray-100 lg:py-12 lg:px-12"
            >
                <div class="flex justify-between">
                    <h1
                        class="mb-3 text-xl font-bold text-primary-200 md:text-3xl"
                    >
                        {{ moment(this.date).format('D. M. YYYY') }}
                    </h1>
                    <p class="mb-3 text-xl font-bold text-gray-500 md:text-3xl">
                        {{
                            moment(this.date)
                                .locale('cs')
                                .format('dddd')
                        }}
                    </p>
                </div>
                <div class="flex flex-wrap -mx-2">
                    <div
                        class="w-full px-2 mb-4 sm:flex-1 md:mb-0"
                        v-for="data in houses"
                        :key="data.house.id"
                    >
                        <House :data="data" />
                    </div>
                </div>
            </div>
        </div>
        <OrderForm
            @close="closeModal"
            @refetch-timeline="fetchTimeline(date)"
            :show="showForm"
            :selected-date="date"
            :avaliable-duration="avaliableDuration"
            :selected-time="time"
            :selected-house="house"
        />
    </div>
</template>

<script>
// node_modules
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import axios from 'axios'
import { cs } from 'vuejs-datepicker/dist/locale'

// components
import OrderForm from './components/Form.vue'
import House from './components/House.vue'

export default {
    data() {
        return {
            cs,
            disabledDates: {
                // Open weekends days
                to: new Date(Date.now())
                // to: new Date(Date.now() - 8640000),
                // customPredictor: function(date) {
                //     let dateValue = date.getDay()
                //     return (dateValue == 0 || dateValue == 6)
                // }
            },
            date: null,
            houses: [],
            from: null,
            time: null,
            house: null,
            showForm: false,
            avaliableDuration: '00:00:00'
        }
    },
    watch: {
        date(newVal) {
            this.$nextTick(() => {
                this.fetchTimeline(newVal)
            })
        }
    },
    mounted() {
        let today = new Date()
        let tomorrow = new Date()
        tomorrow.setDate(today.getDate() + 1)

        this.date = tomorrow

        this.fetchTimeline(this.date)
        this.$root.$on('showModal', data =>
            this.showModal(data.house, data.time, data.avaliableDuration)
        )
    },
    methods: {
        moment,
        fetchTimeline(date = this.date) {
            axios
                .get(`${process.env.VUE_APP_API_URL}/reservations`, {
                    params: {
                        from: this.moment(date).format('YYYY-MM-DD')
                    }
                })
                .then(({ data }) => {
                    this.houses = data
                })
        },
        showModal(house, time, avaliableDuration) {
            this.time = time
            this.house = house
            this.avaliableDuration = avaliableDuration
            this.showForm = true
        },
        closeModal() {
            this.time = null
            this.house = null
            this.showForm = false
        }
    },
    components: {
        Datepicker,
        OrderForm,
        House
    }
}
</script>
